import { render, staticRenderFns } from "./DocumentLayoutUpdate.vue?vue&type=template&id=e4e54afc"
import script from "./DocumentLayoutUpdate.vue?vue&type=script&lang=js"
export * from "./DocumentLayoutUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports